import type { FC } from "react";
import styled from "styled-components";
import type { IconName } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, rgba } from "@similarweb/styles";
import { CenteredFlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { i18nFilter } from "app/filters/i18nFilter";

const EmptyStateTitle = styled.div<{ isSmallWidget: boolean; fontColor?: string }>`
    font-size: 16px;
    color: ${({ isSmallWidget }) =>
        isSmallWidget ? rgba(colorsPalettes.carbon[500], 0.6) : colorsPalettes.carbon[500]};
`;

const EmptyStateSubTitle = styled.div`
    color: ${rgba(colorsPalettes.carbon[500], 0.6)};
    font-size: 12px;
    text-align: center;
`;

const EmptyStateContainer = styled(CenteredFlexColumn)`
    height: 290px;
    padding: 24px;
`;

const EmptyStateIcon = styled(SWReactIcons)<{ isSmallWidget?: boolean }>`
    svg {
        width: ${({ isSmallWidget }) => (isSmallWidget ? "100px" : "160px")};
        height: ${({ isSmallWidget }) => (isSmallWidget ? "40px" : "99px")};
    }
`;

interface IEmptyStateProps {
    titleKey: string;
    subTitleKey?: string;
    isSmallWidget?: boolean;
    iconName?: IconName;
}

export const EmptyState: FC<IEmptyStateProps> = (props: IEmptyStateProps) => {
    const { titleKey, subTitleKey, isSmallWidget = false, iconName = "no-data-lab" } = props;
    const i18n = i18nFilter();
    return (
        <EmptyStateContainer>
            <EmptyStateIcon
                iconName={iconName}
                isSmallWidget={isSmallWidget}
            />
            <EmptyStateTitle isSmallWidget={isSmallWidget}>{i18n(titleKey)}</EmptyStateTitle>
            {!isSmallWidget && <EmptyStateSubTitle>{i18n(subTitleKey)}</EmptyStateSubTitle>}
        </EmptyStateContainer>
    );
};
